export default "__VITE_ASSET__BkuOpTzl__"